/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `category_1` - Alpinism, pescuit subacvatic, sport alpin, box, luptă, lupte marţiale, paraşutism, sport aviatic, genuri tehnice de sport, ce ţine de viteze maximă
 * * `category_2` - Atletica uşoară, atletica grea, schi, jocuri sportive, biatlon, sărituri în apă, ridicarea greutăţilor, windsurfing, etc.
 * * `category_3` - Înot, tragere la ţintă, tenis de masă, orientare sportivă, badminton, tenis de câmp, sprint şi alte genuri de sport, cu excepţia celor ce nu necesită depunerea efortului fizic (radiosport, biliard, aeromodelism, şah)
 */
export enum SportCategoryEnum {
  CATEGORY_1 = 'category_1',
  CATEGORY_2 = 'category_2',
  CATEGORY_3 = 'category_3',
}
